/* 🤖 this file was generated by svg-to-ts */
export const siriusSquareHalfVertical: {
  name: 'square_half_vertical';
  data: string;
} = {
  name: 'square_half_vertical',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.875 3.375a1.5 1.5 0 0 0-1.5 1.5v14.25a1.5 1.5 0 0 0 1.5 1.5h14.25a1.5 1.5 0 0 0 1.5-1.5V4.875a1.5 1.5 0 0 0-1.5-1.5H4.875Zm6.375 1.5H4.875v14.25h6.375V4.875Zm1.5 14.25V4.875h6.375v14.25H12.75Z" fill="currentColor"/></svg>`
};
